export enum Stat {
  gender = "Gender",
  registrations = "Registrations",
  registrationsOccupations = "Registrations (by Occupation)",
  birthYears = "Birth Year",
  birthYearsMale = "Birth Year (Male)",
  birthYearsFemale = "Birth Year (Female)",
  linkedin = "LinkedIn Links",
  linkedinRegistration = "LinkedIn Links by Registration Date",
  unhcrRegistered = "UNHCR Registered",
  unhcrStatus = "UNHCR Status",
  referrers = "Referrers",
  referrersMale = "Referrers (Male)",
  referrersFemale = "Referrers (Female)",
  nationalities = "Nationalities",
  nationalitiesMale = "Nationalities (Male)",
  nationalitiesFemale = "Nationalities (Female)",
  nationalitiesJordan = "Nationalities (Jordan)",
  nationalitiesLebanon = "Nationalities (Lebanon)",
  sourceCountries = "Source Countries",
  sourceCountriesMale = "Source Countries (Male)",
  sourceCountriesFemale = "Source Countries (Female)",
  statuses = "Statuses",
  statusesMale = "Statuses (Male)",
  statusesFemale = "Statuses (Female)",
  statusesJordan = "Statuses (Jordan)",
  statusesLebanon = "Statuses (Lebanon)",
  occupations = "Occupations",
  occupationsMale = "Occupations (Male)",
  occupationsFemale = "Occupations (Female)",
  occupationsCommon = "Most Common Occupations",
  occupationsCommonMale = "Most Common Occupations (Male)",
  occupationsCommonFemale = "Most Common Occupations (Female)",
  maxEducation = "Max Education Level",
  maxEducationMale = "Max Education Level (Male)",
  maxEducationFemale = "Max Education Level (Female)",
  languages = "Languages",
  languagesMale = "Languages (Male)",
  languagesFemale = "Languages (Female)",
  survey = "Survey",
  surveyJordan = "Survey (Jordan)",
  surveyLebanon = "Survey (Lebanon)",
  surveyMale = "Survey (Male)",
  surveyFemale = "Survey (Female)",
  spokenEnglish = "Spoken English Language Level",
  spokenEnglishMale = "Spoken English Language Level (Male)",
  spokenEnglishFemale = "Spoken English Language Level (Female)",
  spokenFrench = "Spoken French Language Level",
  spokenFrenchMale = "Spoken French Language Level (Male)",
  spokenFrenchFemale = "Spoken French Language Level (Female)"
}
